import React from "react";
var __jsx = React.createElement;
/** ------- Imports Dependencies ------- */

/** ------- Import Styles ------- */
import stl from './Bulleted-list-cards.module.css';
import { useCMS } from "@hooks/useCMS";

/** ------- Type Declarations ------- */

/** ------- Component ------- */

var BulletedListCard = function BulletedListCard(_ref) {
  var list_items = _ref.list_items,
    title = _ref.title,
    icon = _ref.icon;
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.InstallmentConditionsCard
  }, /*#__PURE__*/React.createElement("h3", {
    className: stl.cardTitle
  }, title), /*#__PURE__*/React.createElement("ul", {
    className: stl.InstallmentConditionsList
  }, list_items.split('\n').filter(function (item) {
    return item.trim() !== '';
  }).map(function (item, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: "installment-condition-".concat(index),
      className: stl.InstallmentConditionsItem
    }, /*#__PURE__*/React.createElement("img", {
      src: imageUrl(icon),
      alt: icon.caption || "bullet",
      className: stl.bulletIcon,
      width: "24px",
      height: "24px"
    }), /*#__PURE__*/React.createElement("span", {
      className: stl.termText
    }, item));
  }))));
};
export default BulletedListCard;